import * as React from "react";
import { Notification } from "@/components/admin/notification";
import { useConfigurationContext } from "@/components/atomic-crm/root/ConfigurationContext";

// Sign-in related screens: one centered column with the logo on top, the
// same minimal pattern as the sign-in page.
export const Layout = ({ children }: React.PropsWithChildren) => {
  const { darkModeLogo, title } = useConfigurationContext();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 py-12">
      <div className="w-full max-w-[360px] space-y-8">
        <img className="mx-auto h-11" src={darkModeLogo} alt={title} />
        <div className="flex flex-col space-y-6">{children}</div>
      </div>
      <Notification />
    </div>
  );
};
